import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityService } from 'app/shared/service/entity.service';
import { AppConfigService } from 'app/shared/service/app-config.service';

import { IEntityInfo, IPage, IEntityWithPageInfo } from '@briebug/ngrx-auto-entity';
import { Observable } from 'rxjs';
import { Criteria } from '../utils/criteria.model';
import { map } from 'rxjs/operators';
import { Panne } from 'app/main/panne/panne.model';

@Injectable({
    providedIn: 'root'
})
export class AbstractNotificationService extends EntityService<Notification> {

    private stompClient;


    constructor(private _http: HttpClient, private _configService: AppConfigService) {
        super(_http, _configService);
        ///this.initializeWebSocketConnection();
    }

    // initializeWebSocketConnection() {
    //     const socket = new SockJS('http://localhost:8080/websocket-endpoint');
    //     this.stompClient = Stomp.over(socket);
    //     this.stompClient.connect({}, () => {
    //       this.stompClient.subscribe('/user/notifications', (message) => {
    //         // Handle received notification
    //       });
    //     });
    // }

    // sendNotification(notification: any) {
    //     this._http.post('http://localhost:8080/notifications/send', notification).subscribe();
    //   }

    loadPage(entityInfo: IEntityInfo, page: IPage, criteria?: Criteria): Observable<IEntityWithPageInfo<Notification>> {
        let params = new HttpParams()
            .set("page", page.page.toString())
            .set("size", page.size.toString());

        if (criteria) {
            if (criteria.sort) {
                params = params.set("sort", criteria.sort.field)
                    .set("dir", criteria.sort.dir);
            }
        }
        return this._http.get<any>(`${this._configService.config.apiUrl}/${this.getEntityUri(entityInfo)}/user`, { params: params }).pipe(
            map(response => ({
                pageInfo: {
                    page: { page: page.page, size: page.size },
                    totalCount: response.totalElements
                },
                entities: response.content
            }))
        );
    }
   
    sendNotification( notification: any) {
        this._http.post(`${this._configService.config.apiUrl}/notifications/send_notification`, notification).subscribe();
    }

    sendNotificationToMobile( notification: any) {
        this._http.post(`${this._configService.config.apiUrl}/notifications/send-mobile-notifications`, notification).subscribe();
    }

} 